<template>
    <section class="py-3 py-md-3 mb-3 bg-BAT">
        <div class="container px-3">
            <div class="breadcrumbs-retos">
                <a @click="showExitModal('home')">
                    <img src="/img/icons/homeBread.svg" alt="" />
                </a>
                <a class="link cursor-pointer" @click="showExit = true">A la practica</a>
                <a class="link cursor-pointer" @click="showExit = true">Retos /</a>
                <span class="color-active-miga"><strong>{{ challenge.challenge_name }}</strong></span>
            </div>

            <a class="pb-2" @click="showExit = true">
                <img src="/img/icons/regresar.svg" alt="icon" />
            </a>

            <div class="header-portfolio d-flex flex-column pt-4">
                <h5>¡Manos a la obra!</h5>
                <span>Actividad 1: Sube una foto</span>
            </div>
        </div>

        <div class="container-md upload-photo">
            <section class="challenge-upload-photo">
                <h6 class="title">{{ challenge.challenge_name }}</h6>
                <span v-html="challenge.description"></span>

                <div v-if="approved" class="alert"
                     :class="{ 'alert-success': approved.is_approved === 'true', 'alert-danger': approved.is_approved === 'false', 'alert-warning': approved.is_approved === 'review', 'alert-secondary': approved.is_approved === 'read' }">
                    <span v-if="approved.is_approved === 'true'">Reto completo</span>
                    <span v-if="approved.is_approved === 'false'">Reto no aprobado</span>
                    <span v-if="approved.is_approved === 'review'">En revisión</span>
                    <span v-if="approved.is_approved === 'read'">No ha participado</span>
                </div>
            </section>

            <form enctype="multipart/form-data" id="form-challenge-photo" @submit.prevent="submit">
                <div class="row">
                    <div class="my-4" v-for="(i, index) in challenge.quantity_photo" :key="index" :class="{
                    'col-12': challenge.quantity_photo === 1,
                    'col-12 col-md-6': challenge.quantity_photo === 2,
                    'col-12 col-md-4': challenge.quantity_photo >= 3
                  }">
                        <div v-if="challenge.quantity_photo === 2" class="photo-title">
                            <h6 class="title">{{ i === 1 ? challenge.description_image_1 : challenge.description_image_2 }}</h6>
                        </div>
                        <div class="custom-upload-wrapper" :class="{ 'single-upload': challenge.quantity_photo === 1 }">
                            <input
                                type="file"
                                :id="'photo-input-' + index"
                                class="custom-upload-input"
                                accept="image/*"
                                @change="handleFileSelect($event, index)"
                            />
                            <label :for="'photo-input-' + index" class="custom-upload-label">
                                <img v-if="previews[index]" :src="previews[index]" class="preview-image" />
                                <div v-else class="upload-placeholder">
                                    <i class="upload-icon"></i>
                                    <div class="upload-text">
                                        {{ isProcessing[index] ? 'Procesando...' : 'Subir foto ' + i }}
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <section class="button-send my-4">
                    <button id="btn-send-challenges" class="enviar" type="button" @click="submit()" :disabled="isLoading || isAnyProcessing">
                        {{ isLoading ? 'Enviando...' : 'Enviar reto' }}
                    </button>
                </section>
            </form>
        </div>

        <el-dialog :visible.sync="showCompletion" :width="$mq === 'sm' ? '95%' : '35%'" :close-on-press-escape="false"
                   :close-on-click-modal="false" :show-close="false">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break">
                <div class="modal-dialog modal-sm">
                    <div class="modal-content">
                        <div class="d-flex justify-content-center mt-4">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <div class="modals">
                            <h6 class="mb-3">Enviando reto</h6>
                            <p class="mt-2">En unos minutos podrás seguir navegando</p>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="showExit" :width="$mq === 'sm' ? '95%' : '35%'" :close-on-press-escape="false"
                   style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
                   :close-on-click-modal="false" :show-close="false">
            <div class="modals modal-staff">
                <img src="/img-version2/icons/staff/dangerstaff.svg" alt="Icono">
                <h6 class="mx-auto text-title-bat" style="width: auto!important; max-width: 268px!important;">¿Estás seguro que deseas salir?</h6>
                <p class="text-bat px-0">Si sales, el progreso de tu reto <strong class="h6">no </strong>será guardado</p>
            </div>
            <div class="d-flex align-items-center flex-column justify-content-center px-0">
                <div>
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="buttonTwoStaff" type="buttoYes" @click="confirmExit()">Si, continuar</div>
                    </div>
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="text-more cursor-pointer buttonOne" type="buttoNot" @click="showExit =  false">Cancelar</div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="showWinner" :width="$mq === 'sm' ? '95%' : '35%'" :close-on-press-escape="false"
                   style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
                   :close-on-click-modal="false" :show-close="false">
            <div class="modals modal-staff">
                <img src="/img-version2/modal/cup.svg" alt="Icono">
                <h6 class="mx-auto text-title-bat" style="width: auto!important; max-width: 268px!important;">¡Felicitaciones!</h6>
                <p class="text-bat px-0">{{ challenge.points_to_win}} puntos</p>
            </div>
            <div class="d-flex align-items-center flex-column justify-content-center px-0">
                <div>
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="buttonTwoStaff" type="buttoYes" @click="confirmExit()">Aceptar</div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </section>
</template>

<script>
export default {
    props: {
        challenge: {
            default: () => ([]),
        },
        approved: {
            default: () => ([]),
        },
    },
    data() {
        return {
            files: {},
            previews: {},
            isProcessing: {},
            showCompletion: false,
            showExit: false,
            showWinner: false,
            url_return: '/retos?option=challenge',
            isLoading: false
        };
    },
    computed: {
        isAnyProcessing() {
            return Object.values(this.isProcessing).some(status => status === true);
        }
    },
    watch: {
        showExit(oldIndex, newIndex) {
            if (newIndex) {
                this.url_return = '/retos?option=challenge';
            }
        }
    },
    methods: {
        async handleFileSelect(event, index) {
            const file = event.target.files[0];

            if (!file) return;

            const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/heic", "image/heif"];
            if (!allowedTypes.includes(file.type) && !file.name.match(/\.(jpg|jpeg|png|gif|heic|heif)$/i)) {
                this.$message.error("Solo se aceptan jpeg, png, jpg, gif");
                return;
            }

            this.$set(this.isProcessing, index, true);

            try {
                const compressedFile = await this.compressImage(file);

                this.$set(this.files, index, compressedFile);

                this.$set(this.previews, index, URL.createObjectURL(compressedFile));

            } catch (error) {
                console.error("Error procesando imagen:", error);
                this.$message.error("Error al procesar la imagen. Intenta con otra.");
            } finally {
                this.$set(this.isProcessing, index, false);
                event.target.value = '';
            }
        },

        // Redimensiona y comprime la imagen usando Canvas nativo
        compressImage(file) {
            return new Promise((resolve, reject) => {
                const maxWidth = 1920;
                const maxHeight = 1920;
                const quality = 0.7;

                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (event) => {
                    const img = new Image();
                    img.src = event.target.result;
                    img.onload = () => {
                        let width = img.width;
                        let height = img.height;

                        if (width > height) {
                            if (width > maxWidth) {
                                height = Math.round((height *= maxWidth / width));
                                width = maxWidth;
                            }
                        } else {
                            if (height > maxHeight) {
                                width = Math.round((width *= maxHeight / height));
                                height = maxHeight;
                            }
                        }

                        const canvas = document.createElement('canvas');
                        canvas.width = width;
                        canvas.height = height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);

                        ctx.canvas.toBlob((blob) => {
                            if (!blob) {
                                reject(new Error('Canvas is empty'));
                                return;
                            }

                            const newFile = new File([blob], file.name.replace(/\.[^/.]+$/, "") + ".jpg", {
                                type: 'image/jpeg',
                                lastModified: Date.now()
                            });
                            resolve(newFile);
                        }, 'image/jpeg', quality);
                    };
                    img.onerror = (err) => reject(err);
                };
                reader.onerror = (err) => reject(err);
            });
        },

        async submit() {
            if (this.isAnyProcessing) {
                this.$message.warning("Por favor espera a que las imágenes terminen de procesarse.");
                return;
            }

            const fileKeys = Object.keys(this.files);
            const uploadedCount = fileKeys.length;

            if (uploadedCount !== this.challenge.quantity_photo) {
                this.$message.error(`Debes subir exactamente ${this.challenge.quantity_photo} fotos.`);
                return;
            }

            this.isLoading = true;
            this.showCompletion = true;

            const formData = new FormData();

            fileKeys.forEach(key => {
                const f = this.files[key];
                formData.append('photo[]', f);
            });

            try {
                const response = await axios.post(`/retos/foto/store/${this.challenge.id}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    timeout: 60000
                });

                if (response.status === 200) {
                    this.confirmExit();
                } else {
                    console.error('Failure:', response.data);
                    throw new Error("Respuesta no exitosa del servidor");
                }
            } catch (error) {
                this.showCompletion = false;

                if (error.response) {
                    console.error("Status:", error.response.status);
                    if (error.response.data.message) {
                        alert(error.response.data.message);
                    } else {
                        alert("Ocurrió un error en el servidor. Código: " + error.response.status);
                    }
                } else if (error.request) {
                    alert("No se pudo conectar con el servidor. Revisa tu conexión.");
                } else {
                    alert("Error inesperado: " + error.message);
                }
            } finally {
                this.isLoading = false;
                this.showCompletion = false;
            }
        },

        showExitModal(type = null) {
            if (type !== null) {
                this.url_return = "/home-bat"
            }
            this.showExit = !this.showExit;
        },
        confirmExit() {
            window.location.href = this.url_return;
        }
    }
};
</script>

<style scoped>
.custom-upload-input {
    display: none;
}
</style>
